module.exports = __webpack_public_path__ + "static/media/Berufsorientierung.613b8301.jpg";